import { CustomOption } from "core/catalog";
import { useCallback } from "react";

export function useCustomOptionTooltip() {
  const hasTooltip = useCallback((customOption: CustomOption) => {
    return (
      typeof customOption.tooltip === "string" &&
      customOption.tooltip.trim() !== ""
    );
  }, []);

  return {
    hasTooltip,
  };
}
